// extracted by mini-css-extract-plugin
module.exports = {"container":"current-weather-module--container--1Oe4b","group":"current-weather-module--group--31aV3"};